import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductsDirective } from './products.directive';
export var ProductsComponentNgModule = module(baseModuleId + ".products", [])
    .directive('products', ProductsDirective);
